import React, { useState } from 'react';
import styles from "./WhoAreWeSection.module.css";
import AlbirPopup from 'components/AlbirPopup/AlbirPopup';
import { Trans, useTranslation } from 'react-i18next';

const WhoAreWeSection = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { t } = useTranslation();

    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    return (
        <section className={styles['whoweare-section']}>
            <h1 className={styles['whoweare-header']}>{t('whoWeAre.title')}</h1>
            <div className={styles['whoweare-block']}>
        <div>
            <p>
                <Trans i18nKey="whoWeAre.paragraphs.0"
                       components={{
                        highlight: <span style={{ color: 'rgba(222, 255, 140, 1)' }} />,
                        highlightAlt: <span className={styles.whitetogreen} />
                        }}
                />
            </p>
            <p> <Trans i18nKey="whoWeAre.paragraphs.1"
                       components={{
                            linkKizDance: <a href="https://kiz.dance/mkiz" target="_blank" rel="noopener noreferrer" className={`${styles.whitetogreen} ${styles.link}`} />
                        }}
                    />
            </p>
        </div>
        <div>
            <p> <Trans i18nKey="whoWeAre.paragraphs.2"
                       components={{
                            linkKizDance: <a href="https://kiz.dance/mkiz" target="_blank" rel="noopener noreferrer" className={`${styles.whitetogreen} ${styles.link} ${styles['training-courses']}`} />,
                            popupLink: <span className={styles['rohas-span']} onClick={togglePopup} />
                        }}
                />
            </p>
            <p>
                <Trans i18nKey="whoWeAre.paragraphs.3"
                       components={{
                            highlightAlt: <span className={styles.whitetogreen} />,
                            highlightNested: <span className={styles['navigate-the-world-of-kizomba']} />
                        }}
                />
            </p>
        </div>
        </div>
        {isPopupOpen && <AlbirPopup onClose={() => setIsPopupOpen(false)} />}
        </section>
    );
};

export default WhoAreWeSection;